

app.controller('CIF2-CTRL', function ($scope, $rootScope, $routeParams, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter) {

    $scope.listBankRDN = ['BCA (Online)', 'MANDIRI (Offline)', 'CIMB (Offline)', 'MAYAPADA (Offline)'];
    $scope.rdnbca = $scope.listBankRDN[0];
    $scope.bankRDN = '';
    $scope.NPWPLength = 15;
    $scope.disabledNPWPNumber = false;
    $scope.CIFInvestor = {
        QuestionNPWP: '',
        FundSource: '',
        BankNumber: '',
        BankCabang: ''
    }
    $scope.bankpribadi = '';

    $scope.OPBBCA = {
        occupation: '',
        occupationText: '',
        position: '',
        positionText: '',
        business: '',
        businessText : ''
    }

    $scope.OPBOTHER = {
        occupation: '',
        occupationText: '',
        position: '',
        positionText: '',
        business: '',
        businessText: ''
    }

    $scope.OPSPOUSE = {
        occupation: '',
        occupationText: '',
        position: '',
        business: '',
    }

    $scope.checkIDCardNumber = function () {
        if ($scope.CIFInvestor.IDCardNumber && $scope.CIFInvestor.QuestionRDN) {
            $http({
                method: 'GET',
                url: '/service/client.svc/checkIDCardNumber?KTP=' + $scope.CIFInvestor.IDCardNumber + '&QuestionRDN=' + $scope.CIFInvestor.QuestionRDN,
                cache: false
            }).then(function (data) {
                if (data.data.d != null) {
                    var obj = data.data.d;
                    if (obj.key && obj.key == 1) {
                        $scope.CIFInvestor.IDCardNumber = '';
                        Swal.fire('Gagal', obj.value, "error");
                    }
                }
            }, function (error) { });
        }
    }

    $scope.disableBank = false;
    $scope.disablePB = false;
    $scope.disableCIFInvestorQuestionRDN = false;
    $scope.selectedFundSource = [];
    $scope.selectedSpouseFundSource = [];
    $scope.ListBank = {};
    $scope.listpekerjaan_BCA = {};
    $scope.listjabatan_BCA = {};
    $scope.listusaha_BCA = {};
    $scope.ListLookup = [];
    $scope.ListOccupation = [];
    $scope.ListSpouseIncome = [];

    $scope.SpouseCompanyCitySelected = '';
    $scope.mustSelect = function (event, field) {
        if (event.keyCode == 27) {
            $scope.CIFInvestor.DomicileCity = '';
            return false;
        }
        return true;
    }

    $scope.selectCity = function (item, model, label, event) {
        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.SpouseCompanyCity = item.CIFProvinceCityNID;
        }
    };

    $scope.questionRDNchange = function () {

        $scope.OPBBCA.occupation =  '';
        $scope.OPBBCA.occupationText =  '';
        $scope.OPBBCA.position =  '';
        $scope.OPBBCA.positionText =  '';
        $scope.OPBBCA.business =  '';
        $scope.OPBBCA.businessText = '';


        $scope.OPBOTHER.occupation = '';
        $scope.OPBOTHER.occupationText = '';
        $scope.OPBOTHER.position = '';
        $scope.OPBOTHER.positionText = '';
        $scope.OPBOTHER.business = '';
        $scope.OPBOTHER.businessText = '';

        $scope.CIFInvestor.BankName = "";
        $scope.disableBank = false;


        if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {
            $scope.bankpribadi = "PT. BANK CENTRAL ASIA, TBK.";
            $scope.disableBank = true;
        }
        else if ($scope.CIFInvestor.QuestionRDN == '2' || $scope.CIFInvestor.QuestionRDN == 2) {
            $scope.bankpribadi = "";
            $scope.disableBank = false;
        }
        else if ($scope.CIFInvestor.QuestionRDN == '3' || $scope.CIFInvestor.QuestionRDN == 3) {
            $scope.bankpribadi = "";
            $scope.disableBank = false;
        }
        else
        {
            $scope.bankpribadi = "";
            $scope.disableBank = false;
        }
    };

    $scope.changeSpouseMandatory = function (param) {

        if (param)
            $scope.spouseMandatory = true;
        else {
            let flag = false;

            if ($scope.OPBBCA) {
                if ($scope.OPBBCA.occupation.key == 1 || $scope.OPBBCA.occupation.key == 2) {
                    flag = true;
                }
            }

            if ($scope.OPBOTHER) {
                if ($scope.OPBOTHER.CIFLookupInteger == 4 || $scope.OPBOTHER.CIFLookupInteger == 6) {
                    flag = true;
                    $scope.spouseMandatory2 = true;
                    $scope.spouseMandatory1 = false;
                }

            }

            if ($scope.selectedFundSource.indexOf(7) > -1) {
                flag = true;
                $scope.spouseMandatory2 = true;
                $scope.spouseMandatory1 = false;
            }

            if ($scope.selectedFundSource.indexOf(6) > -1) {
                flag = true;
                $scope.spouseMandatory1 = true;
                $scope.spouseMandatory2 = false;
            }

            if (!flag) {
                $scope.CIFInvestor.SpouseCompanyName = '';
                $scope.CIFInvestor.SpouseIncomePerAnnum = '';
                $scope.CIFInvestor.SpouseOccupation = '';
                $scope.CIFInvestor.SpousePosition = '';
                $scope.CIFInvestor.SpouseNatureOfBusiness = '';
                $scope.CIFInvestor.SpouseCompanyCity = '';
                $scope.CIFInvestor.SpouseCompanyPostalCode = '';
                $scope.CIFInvestor.SpouseCompanyAddress = '';
                $scope.CIFInvestor.SpouseFundSource = '';

                $scope.SpouseCompanyCitySelected = '';
                $scope.selectedSpouseFundSource = [];

                $scope.OPSPOUSE.occupation = '';
                $scope.OPSPOUSE.occupationText = '';
                $scope.OPSPOUSE.position = '';
                $scope.OPSPOUSE.business = '';
            }

            $scope.spouseMandatory = flag;
        }
    }

   
    //$scope.testBCA = function () {
    //    $http({
    //        method: 'GET',
    //        url: '/service/client.svc/validateBCA?rek=6910258433&nama=Fajar',
    //        cache: true,
    //    }).then(function (data) {
    //        $scope.ListProvinceCity = data.data.d;
    //    }, function (error) { }),
    //};

    

    $scope.printXyz = function () {
        $scope.prepareData();
    }



    $scope.NPWPNumber = function () {
        if ($scope.CIFInvestor.QuestionNPWP == 1) {
            $scope.CIFInvestor.NPWPNumber = $scope.CIFInvestor.IDCardNumber
            $scope.disabledNPWPNumber = true;
        }
    };

    $scope.updateNPWP = function () {
        if ($scope.CIFInvestor.NPWPNumber) {
            if (+$scope.QuestionNPWP == 1) {
                $scope.CIFInvestor.NPWPNumber;
            }
            else {
                $scope.CIFInvestor.NPWPReason;
                $scope.CIFInvestor.NPWPNumber = '';
            }
        }
    };



    $scope.occupationChange_BCA = function () {
        if ($scope.OPBBCA.occupation) {

            $scope.OPBBCA.occupationText = '';
            $scope.OPBBCA.position = 0;
            $scope.OPBBCA.positionText = '';
            $scope.OPBBCA.business = 0;
            $scope.OPBBCA.businessText = '';

            if ($scope.OPBBCA.occupation.key == 1 || $scope.OPBBCA.occupation.key == 2)
                $scope.changeSpouseMandatory(true);
            else
                $scope.changeSpouseMandatory();

            $http({
                method: 'GET',
                url: '/service/client.svc/GetJabatan?Pekerjaan=' + $scope.OPBBCA.occupation.key,
            }).then(function (data) {
                $scope.listjabatan_BCA = data.data.d;

                if ($scope.listjabatan_BCA.length) {
                    $scope.OPBBCA.positionText = '';
                    $scope.OPBBCA.position = $scope.listjabatan_BCA[0];

                    $scope.positionChange_BCA();
                }
            }, function (error) { });
        }
    };

    $scope.positionChange_BCA = function () {

        if ($scope.OPBBCA.occupation)
        {
            if ($scope.OPBBCA.position)
            {
                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetBidangUsaha?Jabatan=' + $scope.OPBBCA.position.key + '&Pekerjaan=' + $scope.OPBBCA.occupation.key,
                }).then(function (data) {
                    $scope.listusaha_BCA = data.data.d;

                    if ($scope.listusaha_BCA.length) {
                        $scope.OPBBCA.businessText = '';
                        $scope.OPBBCA.business = $scope.listusaha_BCA[0];

                    }
                }, function (error) { });
            }
        }
    };


    $scope.occupationChange_OTHER = function () {
        if($scope.OPBOTHER.occupation)
        {
            $scope.OPBOTHER.occupationText = '';
            $scope.OPBOTHER.position = '';
            $scope.OPBOTHER.positionText = '';
            $scope.OPBOTHER.business = '';
            $scope.OPBOTHER.businessText = '';


            if ($scope.OPBOTHER.occupation == '4' || $scope.OPBOTHER.occupation == '6')
            {
                $scope.changeSpouseMandatory(true);
                if($scope.OPBOTHER.occupation == '6')
                {
                    $scope.OPBOTHER.positionText = 'Pelajar';
                    $scope.disablePB = true;
                }
            }
            else
                $scope.changeSpouseMandatory();
        }
    }





    $scope.toggleFundSourceItem = function (fundsource) {
        let indexCIFLookupInteger = $scope.selectedFundSource.indexOf(fundsource.CIFLookupInteger);

        if (indexCIFLookupInteger > -1)
            $scope.selectedFundSource.splice(indexCIFLookupInteger, 1);
        else
            $scope.selectedFundSource.push(fundsource.CIFLookupInteger);

        if ($scope.selectedFundSource.indexOf(1) < 0)
            $scope.CIFInvestor.FundSourceText = '';

        $scope.changeSpouseMandatory();
   }

    $scope.toggleSpouseFundSourceItem = function (fundsource) {
        $scope.CIFInvestor.SpouseFundSource = '';
        let indexCIFLookupInteger = $scope.selectedSpouseFundSource.indexOf(fundsource.CIFLookupInteger);

        if (indexCIFLookupInteger > -1)
            $scope.selectedSpouseFundSource.splice(indexCIFLookupInteger, 1);
        else
            $scope.selectedSpouseFundSource.push(fundsource.CIFLookupInteger);

        if ($scope.selectedSpouseFundSource.indexOf(1) < 0)
            $scope.CIFInvestor.SpouseFundSourceText = '';
    }

    


    $scope.prepareData = function () {
        console.log($scope.CIFInvestor);

        if ($scope.CIFInvestor.QuestionNPWP)
            $scope.CIFInvestor.QuestionNPWP = Number($scope.CIFInvestor.QuestionNPWP);

        if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1)
        {
            $scope.CIFInvestor.BankName = $scope.bankpribadi;
            $scope.CIFInvestor.Occupation = $scope.OPBBCA.occupation.key;
            $scope.CIFInvestor.Position = $scope.OPBBCA.position.key;
            $scope.CIFInvestor.NatureOfBusiness = $scope.OPBBCA.business.key;

            ////OCCUPATIONTEXT BCA
            //if ($scope.OPBBCA.occupation.key == 18)
            //    $scope.CIFInvestor.OccupationText = $scope.OPBBCA.occupationText;
            //else
            //    $scope.CIFInvestor.OccupationText = $scope.OPBBCA.occupation.value;

            ////POSITIONTEXT BCA
            //if ($scope.OPBBCA.position.key == 0)
            //    $scope.CIFInvestor.PositionText = $scope.OPBBCA.positionText;
            //else
            //    $scope.CIFInvestor.PositionText = $scope.OPBBCA.position.value;

            ////NATUREOFBUSINESSTEXT BCA
            //if ($scope.OPBBCA.business.key == 0)
            //    $scope.CIFInvestor.NatureOfBusinessText = $scope.OPBBCA.businessText;
            //else
            //    $scope.CIFInvestor.NatureOfBusinessText = $scope.OPBBCA.business.value;

            $scope.CIFInvestor.OccupationText = $scope.OPBBCA.occupationText;
            $scope.CIFInvestor.PositionText = $scope.OPBBCA.positionText;
            $scope.CIFInvestor.NatureOfBusinessText = $scope.OPBBCA.businessText;

        }
        else
        {
            $scope.CIFInvestor.Occupation = Number($scope.OPBOTHER.occupation);
            $scope.CIFInvestor.BankName = $scope.bankpribadi;
            $scope.CIFInvestor.OccupationText = $scope.OPBOTHER.occupationText;
            $scope.CIFInvestor.Position = 0;
            $scope.CIFInvestor.NatureOfBusiness = 0;
            $scope.CIFInvestor.OccupationText = $scope.OPBOTHER.occupationText;

            ////OCCUPATION TEXT
            //var occupationDescription = $filter('filter')($scope.ListOccupation, { CIFLookupInteger: Number($scope.OPBOTHER.occupation) }, true)[0];
            //if ($scope.OPBOTHER.occupation == '1')
            //    $scope.CIFInvestor.OccupationText = $scope.OPBOTHER.occupationText;
            //else {
            //    if (occupationDescription != null)
            //        $scope.CIFInvestor.OccupationText = occupationDescription.CIFLookupDescription;
            //}

            //POSITIONTEXT, NATUREOFBUSINESSTEXT
            if ($scope.OPBOTHER.occupation == '4') {
                
                $scope.CIFInvestor.PositionText = '';
                $scope.CIFInvestor.NatureOfBusinessText = '';
            } else {
                $scope.CIFInvestor.PositionText = $scope.OPBOTHER.positionText;
                $scope.CIFInvestor.NatureOfBusinessText = $scope.OPBOTHER.businessText;
            }
           
        }
        
        if ($scope.spouseMandatory)
        {
            $scope.CIFInvestor.SpouseOccupation = Number($scope.OPSPOUSE.occupation);
            $scope.CIFInvestor.SpouseOccupationText = $scope.OPSPOUSE.occupationText;
            $scope.CIFInvestor.SpousePosition = $scope.OPSPOUSE.position;
            $scope.CIFInvestor.SpouseNatureOfBusiness = $scope.OPSPOUSE.business;
        }
        else
        {
            $scope.CIFInvestor.SpouseIncomePerAnnum = 0;
            $scope.CIFInvestor.SpouseOccupation = 0;
            $scope.CIFInvestor.SpouseCompanyCity = 0;
        }
        

        if ($scope.selectedFundSource)
        {
            $scope.CIFInvestor.FundSource = '';
            for (var i = 0; i < $scope.selectedFundSource.length; i++)
            {
                if ($scope.CIFInvestor.FundSource.length > 0)
                    $scope.CIFInvestor.FundSource += ',';
                $scope.CIFInvestor.FundSource += $scope.selectedFundSource[i];

            }
        }


        if ($scope.selectedSpouseFundSource)
        {
            $scope.CIFInvestor.SpouseFundSource = '';
            for (var i = 0; i < $scope.selectedSpouseFundSource.length; i++) {
                if ($scope.CIFInvestor.SpouseFundSource.length > 0)
                    $scope.CIFInvestor.SpouseFundSource += ',';
                $scope.CIFInvestor.SpouseFundSource += $scope.selectedSpouseFundSource[i];

            }
        }

    };
 
    $scope.submit = function () {
        $scope.prepareData();
        var finished = 0;

        console.log('a');

        $scope.working = true;

        $rootScope.AlertYesNo('question', 'Konfirmasi', "Apakah data yang diisi sudah sesuai?")
        .then((result) => {
            if (result.value) {
                $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                $http({
                    method: 'POST',
                    url: '/service/client.svc/SaveCIF',
                    data:
                        {
                            cifdata: $scope.CIFInvestor
                        },
                }).then(function (data) {

                    if (data.data.d.result && $scope.spouseMandatory) {
                        swal.close();
                        $window.location.href = "#/cif/data-benef";
                    }
                    else if (data.data.d.result && !$scope.spouseMandatory) {
                        swal.close();
                        $window.location.href = "#/cif/data-pendukung";
                    }
                    else {
                        swal('Failed', data.data.d.message, 'error');
                    }
                }, function (error) {
                    swal('Error', 'error - Please check your connection', 'error');
                });
            }
        });

    }

    $scope.validationinput = function () {

        if ($scope.CIFInvestor.Email != null || $scope.CIFInvestor.Email != '') {
            $window.location.href = "#/cif/data-pendukung";
        }
        else {
            swal({
                title: 'Push notifications',
                text: 'Email Tidak Boleh Kosong',
                imageUrl: 'img/erdikha/from_erdikha/LoginSelamatDatang.png',
                imageAlt: 'E-KTP',
                width: '400px',
                animation: false
            });
        }
    }


    var allPromise = $q.all([
        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFProvinceCity',
            cache: true,
        }).then(function (data) {
            $scope.ListProvinceCity = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFLookup',
            cache: true,
        }).then(function (data) {
            $scope.ListLookup = data.data.d;
            if ($scope.ListLookup) {
                $scope.ListOccupation = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Occupation' }, true);
                $scope.ListSpouseIncome = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
                $scope.ListFundSource = $filter('filter')($scope.ListLookup, { CIFLookupID: 'FundSource' }, true);
                $scope.ListIncomePerAnnum = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
            }
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFBank',
            cache: true,
        }).then(function (data) {
            $scope.ListBank = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFPekerjaan',
            cache: true,
        }).then(function (data) {
            $scope.listpekerjaan_BCA = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetJabatan',
            cache: true,
        }).then(function (data) {
            $scope.listposition_BCA = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetBidangUsaha',
            cache: true,
        }).then(function (data) {
            $scope.listnature_BCA = data.data.d;
        }, function (error) { }),
    ]);

    allPromise.then(function () {
        $http({
            method: 'GET',
            url: '/service/client.svc/getCIF',
        }).then(function (data) {
            if (data.data.d != null) {
                var obj = data.data.d;
                $scope.CIFInvestor = data.data.d;
                $scope.CIFInvestor.Stage = 2;

                if ($scope.CIFInvestor.QuestionRDN == 0) {
                    $scope.CIFInvestor.QuestionRDN = '';
                }

                $scope.CIFInvestor.BankOwner = $scope.CIFInvestor.FirstName;
                
                $scope.bankpribadi = $scope.CIFInvestor.BankName;
                $scope.BankNumber = $scope.CIFInvestor.BankNumber;
                $scope.BankCabang = $scope.CIFInvestor.BankCabang;

                if ($scope.CIFInvestor.SpouseCompanyCity)
                    $scope.SpouseCompanyCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: $scope.CIFInvestor.DomicileCity }, true)[0];

                if($scope.CIFInvestor.QuestionRDN)
                {
                    if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1)
                    {
                        $scope.OPBBCA.occupationText = $scope.CIFInvestor.OccupationText;
                        $scope.OPBBCA.positionText = $scope.CIFInvestor.PositionText;
                        $scope.OPBBCA.businessText = $scope.CIFInvestor.NatureOfBusinessText;

                        $scope.bankpribadi = "PT. BANK CENTRAL ASIA, TBK.";
                        $scope.disableBank = true;

                        if ($scope.CIFInvestor.Occupation && $scope.CIFInvestor.Occupation > 0)
                        {
                            $scope.OPBBCA.occupation = $filter('filter')($scope.listpekerjaan_BCA, { key: $scope.CIFInvestor.Occupation }, true)[0];
                           
                            $http({
                                method: 'GET',
                                url: '/service/client.svc/GetJabatan?Pekerjaan=' + $scope.OPBBCA.occupation.key,
                            }).then(function (data) {
                                $scope.listjabatan_BCA = data.data.d;
                                if ($scope.listjabatan_BCA.length) {
                                        $scope.OPBBCA.position = $filter('filter')($scope.listjabatan_BCA, { key: $scope.CIFInvestor.Position }, true)[0];
                                        $http({
                                            method: 'GET',
                                            url: '/service/client.svc/GetBidangUsaha?Jabatan=' + $scope.OPBBCA.position.key + '&Pekerjaan=' + $scope.OPBBCA.occupation.key,
                                        }).then(function (data) {
                                            $scope.listusaha_BCA = data.data.d;
                                            if ($scope.listusaha_BCA.length) {                                               
                                                    $scope.OPBBCA.business = $filter('filter')($scope.listusaha_BCA, { key: $scope.CIFInvestor.NatureOfBusiness }, true)[0];
                                            }
                                        }, function (error) { });

                                }
                            }, function (error) { });
                        }
                            
                    }
                    else
                    {
                        $scope.OPBOTHER.occupation = $scope.CIFInvestor.Occupation;
                        $scope.OPBOTHER.occupationText = $scope.CIFInvestor.OccupationText;
                        $scope.OPBOTHER.position = $scope.CIFInvestor.Position;
                        $scope.OPBOTHER.positionText = $scope.CIFInvestor.PositionText;
                        $scope.OPBOTHER.business = $scope.CIFInvestor.NatureOfBusiness;
                        $scope.OPBOTHER.businessText = $scope.CIFInvestor.NatureOfBusinessText;

                    }
                }

                if ($scope.CIFInvestor.SpouseCompanyCity == 0)
                    $scope.CIFInvestor.SpouseCompanyCity = '';

                if ($scope.CIFInvestor.FundSource) {
                    $scope.selectedFundSource = [];
                    let temp = $scope.CIFInvestor.FundSource.split(',');
                    for (var i = 0; i < temp.length; i++) {
                        
                        $scope.selectedFundSource.push(Number(temp[i]));
                       
                    }
                }
              
                if ($scope.CIFInvestor.SpouseFundSource) {
                    $scope.selectedSpouseFundSource = [];
                    let temp = $scope.CIFInvestor.SpouseFundSource.split(',');

                    for (var i = 0; i < temp.length; i++) {
                        $scope.selectedSpouseFundSource.push(Number(temp[i]));
                    }
                }


                if ($scope.CIFInvestor.QuestionNPWP == 0)
                    $scope.CIFInvestor.QuestionNPWP = '';

                if ($scope.CIFInvestor.IncomePerAnnum == '')
                    $scope.CIFInvestor.IncomePerAnnum == 0;


                $scope.changeSpouseMandatory();
                $scope.OPSPOUSE.occupation = $scope.CIFInvestor.SpouseOccupation;
                $scope.OPSPOUSE.occupationText = $scope.CIFInvestor.SpouseOccupationText;
                $scope.OPSPOUSE.position = $scope.CIFInvestor.SpousePosition;
                $scope.OPSPOUSE.business = $scope.CIFInvestor.SpouseNatureOfBusiness;

            } // END IF data.data.d
        }, function (error) { });
    });


    $scope.logOff = function () {
        $http({
            method: 'POST',
            url: '/service/client.svc/logOff',
        }).then(function (data) {
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };

});





